import {Button, createStyles} from '@mantine/core';
import React from 'react';

import * as analytics from 'analytics/Analytics';
import {ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';
import {ACTION_CATEGORY} from 'constants/AnalyticsConstants';

const useStyles = createStyles((theme) => ({
  root: {
    fontWeight: theme.other.fontWeights.normal,
  },
}));

export default function CreatePDFButton({onOpenPreview}: {onOpenPreview: () => void}): JSX.Element {
  const {classes} = useStyles();

  return (
    <Button
      classNames={{root: classes.root}}
      onClick={() => {
        analytics.trackEventWithModule(
          {
            module: ANALYTICS_MODULE.MOLBIO,
            action: 'clicked_create_pdf',
            actionCategory: ACTION_CATEGORY.READ,
          },
          ANALYTICS_MODULE.MOLBIO,
          {}
        );
        onOpenPreview();
      }}
      size="xs"
      variant="tertiary"
    >
      Create PDF
    </Button>
  );
}
